import isUserOrgRolesValid from './isUserOrgRolesValid'
import isUserAddonsValid from './isUserAddonsValid'
import orgIsPayLocked from './orgIsPayLocked'
import { USER_ADDONS } from '../constants/userAddons'
import userHasOnlySpecificAddons from './userHasOnlySpecificAddons'
import isOrgAddonsValid from './isOrgAddonsValid'
import hasPermission from './hasPermission'

const sidebarOptionWithAuth = (sidebarOptions) => {
  const filteredByRoleAndAddonsOptions = sidebarOptions.filter(
    (option) =>
      (option.requiredPermission
        ? hasPermission(option.requiredPermission)
        : isUserOrgRolesValid(option.allowedUserOrgRoles)) &&
      (isOrgAddonsValid(option.allowedOrgAddons) && isUserAddonsValid(option.allowedAddons)),
  )

  // if user has only stats should not be able to see any page that is pay locked
  if (orgIsPayLocked() && userHasOnlySpecificAddons([USER_ADDONS.STATS]))
    return filteredByRoleAndAddonsOptions.map((option) => {
      if (
        (option.allowedAddons.includes(USER_ADDONS.STATS) &&
          (option.name !== 'subscription' || option.name !== 'orgUsers')) ||
        option?.payLocked
      ) {
        return { ...option, disabled: true }
      } else {
        return option
      }
    })

  if (orgIsPayLocked())
    return filteredByRoleAndAddonsOptions.map((option) => {
      // the subscription page should be visible even if subscription state is inactive
      if (option.allowedAddons.includes(USER_ADDONS.STATS) && option.name !== 'subscription') {
        return { ...option, disabled: true }
      } else {
        return option
      }
    })

  return filteredByRoleAndAddonsOptions
}

export default sidebarOptionWithAuth
